import { getLang, setLang, onLangChange } from "../i18n/t";

export function mountLangToggle(parent: HTMLElement) {
  const wrap = document.createElement("div"); wrap.id = "lang";
  const zh = document.createElement("button"); zh.textContent = "中";
  const en = document.createElement("button"); en.textContent = "EN";
  wrap.append(zh, en); parent.appendChild(wrap);

  const sync = () => {
    const cur = getLang();
    zh.classList.toggle("active", cur === "zh");
    en.classList.toggle("active", cur === "en");
    document.documentElement.lang = cur;
  };
  zh.addEventListener("click", () => setLang("zh"));
  en.addEventListener("click", () => setLang("en"));
  onLangChange(sync); sync();
}
